import React from 'react';
import {useState, useContext, /* useMemo,*/ useCallback} from 'react';
import "./style.css";
import {Error} from '../../components/Erro';
import Loading from '../Loading';

import api from '../../services/api';
import {UserContext} from '../../hooks/UserContext'
// import useFind from '../../hooks/useFind'

const states = { // estados possiveis
    INIT:'INIT',
    START:'START',
    PRE_START:'PRE_START',
    LOADING:'LOADING',
    RESULTS:'RESULTS',
    ERROR:'ERROR',
    JAFEZ:'JAFEZ',
    //POP_MSG:'POP_MSG',
}

function Quiz(props) {
    const {quiz_data} = props;
    const quiz_id = quiz_data.id;

    const [state, setState] = useState(states.INIT)
    const { user } = useContext(UserContext);
    const user_id = user?.id;
        //const {user_id,quiz_id} = props
    const [telaCheia, setTelaCheia]     = useState(false);
    const [error, setError]             = useState();//{messages:"eita"}
    const [pergunta, setPergunta]       = useState({});
    const [n_pergunta, setN_pergunta]   = useState(1);
    const [msg, setMsg]                 = useState('');
    const [acertos, setAcertos]         = useState([]);
    const [teste, setTeste]             = useState(false);

    //console.log('q>>pergunta',pergunta)
    //console.log('dj>>pergunta',pergunta)
    //{!!error && <Error error={error.messages}/>}

    if (!user_id){
        setMsg('Faça o login novamente')
        setError('Usuario não conectado')
        setState('ERROR')
    }

    const carregar = useCallback(
        async () => {
           const data = await apiQuizStart({user_id,quiz_id, n_pergunta,teste})
           if (data.success){
                //await setState('LOADING')
                await setPergunta(data.pergunta)
            } else {
                setError(data)
            }
        },
        [user_id,quiz_id,n_pergunta,teste],
    )
    const testeJaFez = useCallback(
        async () => {
            const user_quiz = await apiGet(`/user/qu${user_id}`);
            console.log("user_quiz",user_quiz)
            // console.log('user_quiz',user_quiz)
            if (user_quiz.quizzizes.some(x=>x.id===quiz_id)){
                console.log('ja fez')
                setState(states.JAFEZ)
                setTeste(true)
            }
        },
        [user_id,quiz_id],
        // [user_id],
    )
    /*Teste se ja fez o quiz antes*/
    if(state === states.INIT){
        testeJaFez()
    }


    if(state === states.PRE_START){
        (async () => {
            await setState(states.LOADING)
            await carregar()
            setTimeout(() => {
                setMsg(n_pergunta===quiz_data.n_perguntas-1? 'Última pergunta!':'');
                if (n_pergunta>=quiz_data.n_perguntas){
                    setTelaCheia(false)
                    return setState(states.RESULTS)
                }
                setState(states.START)
            }, 1500);

        })()
    }
    //memoizedCallback();
    //return (<>{'ok'}</>)
    //-dj//console.log('log',{error, pergunta})

    return (
        <div id="quiz" className={!!telaCheia ? 'quiz quiz-pop' : 'quiz quiz-pre-start'} style={!!teste?{'background-color':'var(--bg-quiz-mt)'}:{}}>
            <div>
                <i className={`maxmin ${!!telaCheia ? "fi-rr-compress-alt" : "fi-rr-expand"}`} title="clique aqui para mudar o tamanho da tela" onClick={()=>setTelaCheia(t=>!t)}/>
                <div className="Error"> {!!error && <Error error={error.messages}/>} </div>
                {!!teste && <div className="msg modo-treino">{`Quiz no Modo Treino`}</div>}
                {!!acertos?.length>0 && <div className="acertos"> Acertos {acertos.join('\t')}</div>}
                {!!msg && <div className="msg">{`Mensagem: ${msg}`}</div>}
            </div>

            <div className =''>
                { state  === states.JAFEZ   && <QuizJaFez setState={setState} setTelaCheia={setTelaCheia} quiz_data={quiz_data} teste={teste}/>}
                { state  === states.INIT    && <QuizPreStart setState={setState} setTelaCheia={setTelaCheia} quiz_data={quiz_data} teste={teste}/> }
                { state  === states.LOADING && <QuizLoading/> }
                { state  === states.START   && <QuizPergunta
                    setState={setState} pergunta={pergunta}
                    n_pergunta={n_pergunta} setN_pergunta={setN_pergunta}
                    setAcertos={setAcertos}
                    setMsg={setMsg}
                    //carregarPerguntas={carregarPerguntas}
                    teste={teste}
                /> }
                { state  === states.RESULTS && <QuizResults acertos={acertos} pontos_pergunta={quiz_data.pontos} teste={teste}/> }
            </div>
        </div>
    );
}

export default Quiz;

function QuizResults({acertos,pontos_pergunta,teste}){

    let acertos_total = 0;
    acertos.forEach(a =>{
        if (a==="✔"){
            acertos_total=acertos_total+1
        }
    })
    return (
        <div className = "quiz-conteiner" >
            <div className="resultado">
                <h1>Resultado:</h1>
                {
                    acertos.map((alternativa, i) => (<div className='resposta' key={alternativa.key}>
                        {/* alternativa.texto */}
                        {`${i + 1}º : ${alternativa}`}
                    </div>))
                }
                {!teste&&<div>
                    <p>{`Com cada pergunta correta valendo ${pontos_pergunta} pontos`}</p>
                    <p>{`Você acertou: ${acertos_total} pergunta${acertos_total>1?'s':''} e ganhou ${pontos_pergunta * acertos_total} pontos ${acertos_total>=1?'Parabéns!':''}`}</p>
                </div>}

                {!!teste&&<div>
                    <p>{'.'}</p>
                    <p>{'Você está no modo teste de conhecimentos'}</p>
                    <p>{'Neste modo, o quiz não vale pontos'}</p>
                    <p>{'.'}</p>
                    <p>{`Você acertou: ${acertos_total} pergunta${acertos_total>1?'s':''}`}</p>
                </div>}
            </div>
        </div>
    )
}

function QuizLoading({texto}){
    return (
    <div className="quiz-conteiner">
        <Loading texto={texto}/>
    </div>
    )
    //<div>{'LOADING...'} </div>
}

function QuizPreStart(props){
    const {setState,setTelaCheia,quiz_data,teste} = props;

    const OnClick_Start = async (event)=>{
        //-dj//console.log('Iniciando quiz')
        //carregarPerguntas()
        setTelaCheia(true);
        setState(states.PRE_START);
    }

    return (
        <div className="quiz-conteiner">
        <div className={`quiz-info`} style={!!teste?{'background-color':'var(--cor_bloco-mt)'}:{}}>
                <h1>Você só poderá responder o quiz ganhando pontos, uma vez.</h1>
                <p><span className="ico-aviso"/>Nas demais vezes você poderá responder, mas sem ganhar pontos.</p>
            </div>
            <div className={`quiz-info`} style={!!teste?{'background-color':'var(--cor_bloco-mt)'}:{}}>
                <h1>Informações importantes</h1>
                <p>{`O quiz tem ${quiz_data.n_perguntas} perguntas`}</p>
                <p>{`para cada resposta correta você ganha ${quiz_data.pontos} pontos`}</p>
            </div>
            <button className='btn djbtn quiz-btn' onClick={OnClick_Start}>
                <p className="btn djbtn">Iniciar Quiz</p>
            </button>
        </div>
    )
}

function QuizJaFez(props){
    const {setState,setTelaCheia,quiz_data,teste} = props;

    const OnClick_Start = async (event)=>{
        //-dj//console.log('Iniciando quiz')
        //carregarPerguntas()
        setTelaCheia(true);
        setState(states.PRE_START);
    }

    return (
        <div className="quiz-conteiner">
            <div className={`quiz-info`} style={!!teste?{'background-color':'var(--cor_bloco-mt)'}:{}}>
                <h1>Você está no modo Treino!</h1>
                <p><span className="ico-aviso"/>Pois já respondeu este quiz antes.</p>
                <p><span className="ico-aviso"/>Somente a primeira vez é valendo pontos.</p>
            </div>
            <div className={`quiz-info`}  style={!!teste?{'background-color':'var(--cor_bloco-mt)'}:{}}>
                <h1>Informações</h1>
                <p>{`O treino continua tendo ${quiz_data.n_perguntas} perguntas.`}</p>
                {/* <p>{`Você conseguiu na primeira tentavia ${'x'} pontos`}</p> */}
                <p>{` `}</p>
                <p>{`Bons estudos.`}</p>
            </div>
            <button className='btn djbtn quiz-btn' onClick={OnClick_Start}>
                <p className="btn djbtn">Iniciar Teste</p>
            </button>
        </div>
    )
}

function QuizPergunta(props){
    const {
        pergunta,n_pergunta,
        setN_pergunta, setState, setMsg, setAcertos} = props
    //carregarPerguntas()
    const Hc = (pergunta_id,resposta) =>{
        return async (event)=>{

            setState(states.LOADING)
            const validacao = await apiQuizValidar({/*user_id,*/pergunta_id,resposta}).then(
                (data)=>{
                    if (data.success){
                        setMsg(data.messages)
                        setAcertos(resps => {resps.push(data.acertou? "✔" : "❌"); return resps})
                        setState(states.PRE_START)

                        //setState(states.POP_MSG)
                    } else {
                        setState(states.ERROR)
                    }
                    return data
                }
            )

            console.log(validacao.messages)

            //window.alert(validacao.messages)

            await setN_pergunta(n=>n+1)
        }
    }
    //const enviar_resposta = ()=>console.alert('não concluiu o quiz')
    return (<form className="quiz-conteiner">
        <div className="quiz" style={{'background-color':'transparent'}}>
            <div className="pergunta-titulo">
                <p>{`${n_pergunta} ${pergunta.titulo}`}</p>
                <p className="pergunta-autor">Autor: {pergunta.autor}</p>
            </div>
            <div className='alternativas'>
            {pergunta.alternativas.map((alternativa,i) => (
                <div className='btn djbtn' key={alternativa.key} >
                    {/*alternativa.texto*/}

                    <input
                        type="button"
                        onClick={Hc(pergunta.id,alternativa.key)}
                        name={alternativa.key}
                        value={alternativa.texto}
                        className="alternativa"/>
                </div>
            ))}
            </div>
            {/*
                <div className='quiz-btn' onClick={enviar_resposta}>
                    <p className="btn djbtn">Enviar Respostas</p>
                </div>
            */}
        </div>
    </form>)
}


async function apiQuizStart({user_id,quiz_id,teste}){
    const url = !!teste ? '/quiz/start/treino' : '/quiz/start/'
    const data = await api.post(url,{
        user_id,
        quiz_id
    }).then(res => res.data).catch(e=>{
        return {success:false,mensagens:'Erro de conexão, tente novamente mais tarde'}
    })
    return data
}

async function apiQuizValidar({user_id,pergunta_id,resposta}){

    const data = await api.post('/quiz/start/validar',{
        user_id,
        /*quiz_id,*/
        pergunta_id,
        resposta,
    }).then(res => res.data).catch(e=>{
        return {success:false,mensagens:'Erro de conexão, tente novamente mais tarde'}
    })
    return data
}

async function apiGet(url){
    const res =api.get(url).then(res => res.data).catch(e=>{
        return {success:false,mensagens:'Erro de conexão, tente novamente mais tarde'}
    })
    return res
}

//
// const uiicon = {
//     fi_rr_expand:(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 24h-2a1 1 0 010-2h2a3 3 0 003-3v-2a1 1 0 012 0v2a5.006 5.006 0 01-5 5zM1 8a1 1 0 01-1-1V5a5.006 5.006 0 015-5h2a1 1 0 010 2H5a3 3 0 00-3 3v2a1 1 0 01-1 1zm6 16H5a5.006 5.006 0 01-5-5v-2a1 1 0 012 0v2a3 3 0 003 3h2a1 1 0 010 2zM23 8a1 1 0 01-1-1V5a3 3 0 00-3-3h-2a1 1 0 010-2h2a5.006 5.006 0 015 5v2a1 1 0 01-1 1z"/></svg>),
//     fi_rr_compress_alt:(<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.293 2.091L5.4 3.985 1.707.293A1 1 0 00.293 1.707L3.985 5.4 2.091 7.293A1 1 0 002.8 9h4.764A1.436 1.436 0 009 7.564V2.8a1 1 0 00-1.707-.709zM20.015 18.6l1.894-1.894A1 1 0 0021.2 15h-4.764A1.436 1.436 0 0015 16.436V21.2a1 1 0 001.707.708l1.893-1.893 3.692 3.692a1 1 0 001.414-1.414zM16.436 9H21.2a1 1 0 00.708-1.707L20.015 5.4l3.692-3.692A1 1 0 0022.293.293L18.6 3.985l-1.893-1.894A1 1 0 0015 2.8v4.764A1.436 1.436 0 0016.436 9zm-8.872 6H2.8a1 1 0 00-.708 1.707L3.985 18.6.293 22.293a1 1 0 101.414 1.414L5.4 20.015l1.894 1.894A1 1 0 009 21.2v-4.764A1.436 1.436 0 007.564 15z"/></svg>),
// }
